import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../app_config.js";

function useAuthUser() {
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Token from localStorage:", token);
    if (token) {
      console.log(
        "Sending request with Authorization header:",
        `Bearer ${token}`,
      );
      fetch(`${API_BASE_URL}/api/auth/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            if (res.status === 401 || res.status === 403) {
              localStorage.removeItem("token");
              navigate("/login");
            }
            throw new Error("Failed to fetch user data");
          }
          return res.json();
        })
        .then((data) => {
          setUserId(data.id);
          setUsername(data.username);
          setRole(data.role);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching user data:", err);
          setError("Fehler beim Laden der Benutzerdaten");
          setLoading(false);
        });
    } else {
      setError("Nicht eingeloggt");
      setLoading(false);
    }
  }, [navigate]);

  return { userId, username, role, loading, error };
}

export default useAuthUser;
